package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.mouseOverColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.onMouseDown
import com.varabyte.kobweb.compose.ui.modifiers.scale

import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.after
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.ms

val SimpleWithAnimationStyle = CssStyle {

    base {
        Modifier

            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .onMouseDown {
                // JavaScript code to toggle the animation class
                js("this.classList.toggle('mywithanimation');") as Unit
            }
    }
    hover {
        Modifier
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
    }

    // Define the animation class
    cssRule(".mywithanimation") {
        // Add your animation properties here
        // For example:
        Modifier.scale(2)
    }




}
